// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
    apiKey: "AIzaSyDHv_BagXvzb2TBA_XgfGIZlA8YPWyJVFs",
    authDomain: "savecontrolpush.firebaseapp.com",
    projectId: "savecontrolpush",
    storageBucket: "savecontrolpush.appspot.com",
    messagingSenderId: "716862933451",
    appId: "1:716862933451:web:e90c7b0e75d49479768e4e",
    measurementId: "G-YPXP38TJNB"
  };


// Inicializa Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Inicializa Firebase Cloud Messaging
const messaging = getMessaging(firebaseApp);

export { messaging };
